<template>
    <div>
        <v-card
            v-if="$route.query.new === 'y' && isLoggedIn"
            :class="`${
                $vuetify.breakpoint.smAndDown ? 'my-8' : 'mt-8'
            } mx-auto`"
            :max-width="$vuetify.breakpoint.smAndDown ? 230 : 460"
        >
            <v-card-text>
                <div class="circle-loader" :class="loadCompletion">
                    <div v-show="tick" class="checkmark draw"></div>
                </div>
                <p
                    :class="`${
                        $vuetify.breakpoint.smAndDown
                            ? 'subtitle-1 mb-0'
                            : 'display-1'
                    } text-center`"
                >
                    <TranslatableStringComponent :tstring="{string: 'weVeReceivedYourOrder'}" />
                </p>
                <p
                    :class="`${
                        $vuetify.breakpoint.smAndDown
                            ? 'caption'
                            : 'subtitle-1 '
                    } text-center mb-0`"
                >
                    <TranslatableStringComponent :tstring="{string: 'youWebOrderConfirmationNoIs'}" />: <br />
                </p>
                <p v-if="webOrderConfirmationNo" class="subtitle-1 text-center">
                    <b>{{
                        webOrderConfirmationNo.replace('Web Order-', '')
                    }}</b>
                </p>
                <div v-show="!webOrderConfirmationNo" class="spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                </div>
                <div v-if="false" class="text-center">
                    <p class="mb-0">
                        <TranslatableStringComponent :tstring="{string: 'yourFeedbackIsImportantToUs'}" />
                    </p>
                    <v-btn
                        text
                        dense
                        small
                        style="
                            text-transform: capitalize;
                            text-decoration: underline;
                        "
                        color="primary"
                        @click="dialog = true"
                    >
                        <TranslatableStringComponent :tstring="{string: 'rateYourShoppingExperience'}" />
                    </v-btn
                    >
                </div>
            </v-card-text>
        </v-card>
        <v-row v-show="isLoggedIn" column justify-center align-center>
            <v-col cols="12">
                <OrderSummaryMobile
                    v-if="$vuetify.breakpoint.smAndDown"
                    @setWebOrderConfirmationNo="
                        setWebOrderConfirmationNo($event)
                    "
                />
                <OrderSummary
                    v-else
                    @setWebOrderConfirmationNo="
                        setWebOrderConfirmationNo($event)
                    "
                />
            </v-col>
        </v-row>
        <v-row v-show="!isLoggedIn" column justify-center align-center>
            <v-col cols="12">
                <FormLogin :heading="true" />
            </v-col>
        </v-row>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="480"
            style="position: relative"
        >
            <v-card class="pa-4">
                <v-card-title class="subtitle-1 pa-0 mb-4 text-sm-h5">
                    <TranslatableStringComponent :tstring="{string: 'thankYouForYourOrder'}" />
                </v-card-title>
                <FormSurvey
                    :web-order-no="webOrderConfirmationNo"
                    @closeDialog="closeDialog($event)"
                />
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import OrderSummary from '~/components/OrderSummary'
import OrderSummaryMobile from '~/components/OrderSummaryMobile'
import FormSurvey from '~/components/forms/FormSurvey'
import handleAuth from '~/mixins/handleAuth'
import FormLogin from '~/components/forms/FormLogin.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'OrderConfirmation',
    components: {
        OrderSummary,
        OrderSummaryMobile,
        FormLogin,
        FormSurvey,
        TranslatableStringComponent,
    },
    mixins: [handleAuth],
    data() {
        return {
            showHero: false,
            showFooter: true,
            e1: 1,
            tick: false,
            isWebOrderSuccess: true,
            webOrderConfirmationNo: '',
            dialog: false,
        }
    },
    computed: {
        loadCompletion() {
            if (this.isWebOrderSuccess === true) {
                return 'load-complete load-success'
            } else if (this.isWebOrderSuccess === false) {
                return 'load-complete load-failure'
            } else {
                return ''
            }
        },
    },
    mounted() {
        if (this.isWebOrderSuccess === true) {
            this.tick = true
        }
    },
    methods: {
        setWebOrderConfirmationNo(webOrderNo) {
            this.webOrderConfirmationNo = webOrderNo
        },
        closeDialog(event) {
            this.dialog = event
        },
    },
}
</script>
<style lang="scss" scoped>
$loader-size: 8em;
$check-height: $loader-size/2;
$check-width: $check-height/2;
$check-left: ($loader-size/6 + $loader-size/12);
$check-thickness: 3px;
$check-color: $primary;

.circle-loader {
    margin: 0 auto 30px auto;
    border: $check-thickness solid rgba(0, 0, 0, 0.2);
    border-left-color: $primary;
    animation-name: loader-spin;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    position: relative;
    display: block;
    // vertical-align: top;
    margin: 0 auto;
}

.circle-loader,
.circle-loader:after {
    border-radius: 50%;
    width: $loader-size;
    height: $loader-size;
}

.checkmark {
    &.draw:after {
        animation-duration: 1.5s;
        animation-timing-function: ease-in;
        animation-name: checkmark;
        transform: scaleX(-1) rotate(135deg);
    }

    &:after {
        opacity: 1;
        height: $check-height;
        width: $check-width;
        transform-origin: left top;
        border-right: $check-thickness solid $check-color;
        border-top: $check-thickness solid $check-color;
        content: '';
        left: $check-left;
        top: $check-height;
        position: absolute;
    }
}

.load-failure {
    &:before,
    &:after {
        display: block;
        content: '';
        height: 2px;
        background: $error;
        width: 50%;
        position: absolute;
        top: 4em;
        left: 2em;
    }

    &:before {
        transform: rotate(45deg);
    }

    &:after {
        transform: rotate(-45deg);
    }
}

.load-complete {
    -webkit-animation: none;
    animation: none;
    transition: border 500ms ease-out;

    &.load-success {
        border-color: $primary;
    }

    &.load-failure {
        border-color: $error;
    }
}

@keyframes loader-spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes checkmark {
    0% {
        height: 0;
        width: 0;
        opacity: 1;
    }
    20% {
        height: 0;
        width: $check-width;
        opacity: 1;
    }
    40% {
        height: $check-height;
        width: $check-width;
        opacity: 1;
    }
    100% {
        height: $check-height;
        width: $check-width;
        opacity: 1;
    }
}
/*Huge thanks to @tobiasahlin at http://tobiasahlin.com/spinkit/ */
.spinner {
    margin: 0 auto;
    width: 70px;
}

.spinner > div {
    width: 18px;
    height: 18px;
    background-color: #0063a6;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}

.spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
    }
    40% {
        -webkit-transform: scale(1);
    }
}

@keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    40% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}
@media only screen and (max-width: 760px) {
    .v-card {
        box-shadow: none;
    }
    .v-card__text {
        padding: 0;
    }
    .checkmark {
        &:after {
            height: 2em;
            width: 1em;

            border-right: 2px solid #0063a6;
            border-top: 2px solid #0063a6;

            left: 0.75em;
            top: 2em;
            position: absolute;
        }
    }
    .circle-loader,
    .circle-loader:after {
        border: 2px solid rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        width: 4em;
        height: 4em;
    }
    @keyframes checkmark {
        0% {
            height: 0;
            width: 0;
            opacity: 1;
        }
        20% {
            height: 0;
            width: 1em;
            opacity: 1;
        }
        40% {
            height: 2em;
            width: 1em;
            opacity: 1;
        }
        100% {
            height: 2em;
            width: 1em;
            opacity: 1;
        }
    }
}
</style>
